export const validation = {
  password: "Please enter a Password",
  confirmPassword: "Please Re-enter password",
  passwordField:
    "Password should be atleast 6 to 15 character,\nOne Uppercase, One Lowercase,\nOne Number & special Character",
  email: "Please enter a email ",
  validEmail: "Please enter a valid email address",
  help: "What can we help you with  is required",
};
